import { render, staticRenderFns } from "./DragUpload.vue?vue&type=template&id=83df6780&scoped=true"
import script from "./DragUpload.vue?vue&type=script&lang=js"
export * from "./DragUpload.vue?vue&type=script&lang=js"
import style0 from "./DragUpload.vue?vue&type=style&index=0&id=83df6780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83df6780",
  null
  
)

export default component.exports